import React from 'react'
import ModelsContainer from './ModelsContainer'

const Models = () => <ModelsContainer data-test="component-models" />

export default Models
